import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Table } from 'reactstrap';
import Loader from 'components/Loader';
import { mapLiquidationHistoryRows } from '../utils/cryptoUtils';

const LiquidationHistoryPanel = ({
  loanId,
  coinType,
  collateralLiquidations,
}) => {
  const isInitialLoad = Boolean(loanId)
    && collateralLiquidations?.data === undefined
    && !collateralLiquidations?.error;

  if (collateralLiquidations?.isLoading || isInitialLoad) {
    return <Loader className="height-2" />;
  }

  const liquidations = mapLiquidationHistoryRows(collateralLiquidations?.data, coinType);

  return (
    <Table className="mb-0" size="sm" responsive striped borderless>
      <thead>
        <tr>
          <th>Date &amp; Time</th>
          <th>Liquidation Type</th>
          <th>Status</th>
          <th>Reason</th>
          <th>LTV at Trigger</th>
          <th>Collateral Sold</th>
          <th>Exec. Price</th>
          <th>Proceeds</th>
        </tr>
      </thead>
      <tbody>
        {liquidations.length > 0 ? liquidations.map((item, index) => (
          <tr key={`${item.id}-${index}`}>
            <th scope="row">{item.dateTime}</th>
            <td>{item.liquidationType}</td>
            <td>{item.status}</td>
            <td>{item.reason}</td>
            <td>{item.ltvAtTrigger}</td>
            <td>{item.collateralSold}</td>
            <td>{item.execPrice}</td>
            <td>{item.proceeds}</td>
          </tr>
        )) : (
          <tr>
            <td colSpan={8} align="center" className="pt-3 pb-3">No data</td>
          </tr>
        )}
      </tbody>
    </Table>
  );
};

LiquidationHistoryPanel.propTypes = {
  loanId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  coinType: PropTypes.string,
  collateralLiquidations: PropTypes.shape({
    data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    isLoading: PropTypes.bool,
    error: PropTypes.any,
  }),
};

LiquidationHistoryPanel.defaultProps = {
  coinType: 'BTC',
  collateralLiquidations: {},
};

const mapStateToProps = (state) => ({
  collateralLiquidations: state.dashboard.collateralLiquidations,
});

export default compose(
  connect(mapStateToProps)
)(LiquidationHistoryPanel);
